import { useEffect } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "Components/ui/tooltip";
import { useTheme } from "hooks/ThemeContext";

function SectionCard({ icon, title, letter, onClick }) {
  const { theme } = useTheme();

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key.toLowerCase() === letter.toLowerCase()) {
        onClick && onClick();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [letter]);
  return (
    <div
      className="cursor-pointer w-full flex items-center justify-between bg-grey-light p-3 rounded-lg"
      onClick={() => {
        onClick && onClick();
      }}
    >
      <div className="flex items-center gap-4">
        {icon}
        <div className="text-base">{title}</div>
      </div>
      <Tooltip>
        <TooltipTrigger>
          <div
            className={`text-sm ${
              theme === "light" ? "bg-background-secondary" : "bg-background"
            } p-1 rounded-md aspect-square w-7 flex justify-center items-center text-white-opacity cursor-pointer`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {letter}
          </div>
        </TooltipTrigger>
        <TooltipContent className="bg-background text-white-opacity">
          Press {letter} to activate
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
export default SectionCard;
